import { useState } from 'react';
import ReportsNav from '../../components/ReportsNav';
import { useNavigate } from 'react-router-dom';
import { reportsApi } from '../../api/reports';
import { monthsAgo, today } from '../../utils/formatDate';
import DatePickerInput from '../../components/DatePickerInput';

export default function ExportSaft() {
  const navigate = useNavigate();
  const [format, setFormat] = useState('SAFT2.0');
  const [from, setFrom] = useState(monthsAgo(1));
  const [to, setTo] = useState(today());

  const handleExport = () => {
    reportsApi.exportSaft({ format, from, to });
  };

  return (
    <div className="space-y-4">
      <ReportsNav />
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold text-gray-900">SAF-T / i.SAF eksportas</h1>
        <button
          className="px-4 py-2 text-sm font-medium text-primary-700 bg-primary-50 rounded-lg hover:bg-primary-100"
          onClick={() => navigate('/reports/vat')}
        >
          PVM suvestinė
        </button>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 p-4 space-y-4">
        <p className="text-sm text-gray-600">
          Export accounting data in SAFT 2.0/2.01 or i.SAF 1.2 formatas (VMI, invozicinės sąskaitos).
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-xs text-gray-500 mb-1">Format</label>
            <select
              className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md"
              value={format}
              onChange={(e) => setFormat(e.target.value)}
            >
              <option value="SAFT2.0">SAFT 2.0</option>
              <option value="SAFT2.01">SAFT 2.01</option>
              <option value="iSAF1.2">i.SAF 1.2</option>
            </select>
          </div>
          <DatePickerInput
            label="From Date"
            value={from}
            onChange={setFrom}
          />
          <DatePickerInput
            label="To Date"
            value={to}
            onChange={setTo}
          />
        </div>

        <div className="flex justify-end">
          <button
            className="px-6 py-2 text-sm font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700"
            onClick={handleExport}
          >
            Atsisiųsti XML
          </button>
        </div>
      </div>

      {/* Format info */}
      <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 text-xs text-gray-600 space-y-2">
        <h3 className="font-semibold text-gray-700">Formatų aprašymai</h3>
        <div><strong>SAFT 2.0:</strong> Standard Audit File for Tax — full chart of accounts, journal entries, invoices.</div>
        <div><strong>SAFT 2.01:</strong> Updated SAFT version with additional fields.</div>
        <div><strong>i.SAF 1.2:</strong> Invoice-level SAF — lighter format focused on invoice data only.</div>
      </div>
    </div>
  );
}
